import React from 'react';
import { Box, InputBase } from '@mui/material';

type Props = {
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
};

const SearchBar: React.FC<Props> = ({ value, onChange, onBlur }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        width: { xs: '100%', sm: '288px' },
        height: '50px',
        px: 'var(--spacing-3, 12px)',
        py: 'var(--spacing-2, 8px)',
        alignItems: 'center',
        gap: '8px',
        borderRadius: 'var(--Radius-rounded-lg, 8px)',
        border: '1px solid #CECCCC',
        background: '#FFF',
        mt: { xs: '12px', sm: 0 }
      }}
    >
      <InputBase
        placeholder="Search FAQ..."
        value={value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
        onBlur={onBlur}
        sx={{
          flex: 1,
          '&::placeholder': {
            color: '#C1B9B9',
            opacity: 1,
            fontFamily: '"Lato", sans-serif',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: 'normal'
          },
          fontFamily: '"Lato", sans-serif',
          fontSize: '16px',
          fontWeight: 400,
          lineHeight: 'normal'
        }}
        inputProps={{ 'aria-label': 'Search FAQ' }}
      />
      <Box
        component="img"
        src="https://www.performancegolf.com/wp-content/uploads/2025/08/Icon.png"
        alt="Search"
        sx={{ width: 16, height: 24, objectFit: 'contain' }}
      />
    </Box>
  );
};

export default SearchBar;


